<template>
  <div class="expense-modal">
    <form autocomplete="off" @submit.prevent.stop="addExpense">
      <div class="columns mb-1 mt-2">
        <div class="column col-3 form-group">
          <select class="form-select" v-model="filterBySchedule">
            <option :value="true">Da agenda</option>
            <option :value="false">Da tabela do convênio</option>
          </select>
        </div>
        <div
          class="column col-9 form-group"
          :class="!canSearch ? 'tooltip' : ''"
          :data-tooltip="!canSearch ? 'Convênio e profissional devem estar selecionados' : ''"
        >
          <dx-autocomplete
            v-model="expense"
            :source="findExpense"
            label="name"
            track-by="id"
            :disabled="!canSearch"
            :debounce="800"
            @select="addAppointmentExpense"
            placeholder="Informe o código ou nome da consulta ou outros..."
            input-id="expense-name"
          >
            <template v-slot="{ item }">
              <a>
                <fa-icon :icon="['fal', 'file-medical-alt']" class="text-primary"/>
                <span class="ml-1">
                  {{ item.code | tuss }} - {{ item.expense.name }}
                </span>
              </a>
            </template>
            <template v-slot:action>
              <button
                @click="openExpenseModal"
                class="btn btn-action input-group-btn btn-icon btn-neutral"
                :class="{loading: expenseModal.loading}"
                tabindex="-1"
                :disabled="!canSearch || expenseModal.loading"
              ><fa-icon :icon="['fal', 'search']" /></button>
            </template>
          </dx-autocomplete>
        </div>
      </div>
    </form>

    <template v-if="groupedAccounts.length > 0">
      <div v-for="(account) in groupedAccounts" :key="account.key">
        <div class="account">
          <span class="ml-2">Procedimentos agendados</span>
        </div>
        <div style="margin-left: 1rem; margin-bottom: .4rem">
          <table class="table expense-modal-table"
                 :class="account.id ? 'account-finished' : 'table-hover'">
            <tbody>
            <tr v-for="(item) in account.expenses" :key="item.key">
              <td>{{ item.expense.code | tuss }} - {{ item.expense.name }}</td>
              <td class="text-right" width="60px">
                <button class="btn btn-sm btn-gray btn-action btn-icon tooltip"
                        data-tooltip="Preparo"
                        @click="getPreparation(item.expense.id)"
                        v-if="item.expense.code != '10101012'">
                  <fa-icon :icon="['fal', 'info-circle']"></fa-icon>
                </button>
              </td>
              <td class="text-center" width="120px">
                <span v-if="account.id">x{{item.quantity}}</span>
                <span v-else class="tooltip" data-tooltip="Quantidade">
                  <st-input-number-step
                    v-model="item.quantity"
                    :min-value="1"
                    :max-value="20"
                  />
                </span>
              </td>
              <td class="text-right" width="80px">
                <span class="tooltip" data-tooltip="valor unitário">
                  {{ item.particularValue | currency }}
                </span>
              </td>
              <td class="text-right" width="80px">
                <span class="tooltip" data-tooltip="Total">
                  {{ ((item.factor ? item.factor : 1)
                  * item.particularValue * item.quantity) | currency }}
                </span>
              </td>
              <td class="text-right" width="60px">
                <button class="btn btn-sm btn-error btn-action btn-icon tooltip"
                        data-tooltip="Excluir"
                        @click="deleteAppointmentExpense(item)"
                        v-if="!item.accountId">
                  <fa-icon :icon="['fal', 'times']"></fa-icon>
                </button>
              </td>
            </tr>
            </tbody>
          </table>
          <dx-modal title="Informações de preparo"
                    v-model="preparationModal.show" size="lg"
                    v-if="preparationModal.show"
                    id="modal-preparation">
            <div class="preparation-content" v-html="preparation" />
            <template slot="footer">
              <button class="btn btn-gray mr-1"
                      :class="{loading: preparationModal.printing}"
                      :disabled="preparationModal.printing"
                      @click="print">
                <fa-icon :icon="['fal', 'print']" />
                Imprimir
              </button>
              <button class="btn" @click="preparationModal.show = false">Sair</button>
            </template>
          </dx-modal>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="empty">
        <div class="empty-icon">
          <fa-icon :icon="['fal', 'info-circle']" size="3x"/>
        </div>
        <p class="empty-title h5">Procedimentos</p>
        <p class="empty-subtitle">
          Nenhum procedimento encontrado. Informe o código ou nome no campo acima.
        </p>
      </div>
    </template>

    <dx-modal
      title="Lista de procedimentos do profissional"
      v-model="expenseModal.show"
      size="lg"
      v-if="expenseModal.show"
      id="modal-expenses-appointment"
    >
      <div class="empty mt-2"
           v-if="expenseModal.data.items.length === 0 && !expenseModal.loading">
        <div class="empty-icon">
          <fa-icon :icon="['fal', 'info-circle']" size="2x"/>
        </div>
        <p class="empty-title h6">Procedimentos do profissional</p>
        <p class="empty-subtitle">
          Nenhum procedimento encontrado para este profissional. Verifique as configurações.
        </p>
      </div>
      <div class="loading loading-lg mt-2" v-else-if="expenseModal.loading" />
      <table class="table table-hover expense-modal-table" v-else>
        <thead>
        <tr>
          <th>Código</th>
          <th>Nome</th>
          <th class="text-right">Valor Paciente</th>
        </tr>
        </thead>
        <tbody>
        <tr class="c-hand" v-for="(item, i) in expenseModal.data.items" :key="i"
            @click="selectExpense(item)">
          <td>
            <span v-if="item.code">{{ item.code | tuss }}</span>
            <span v-else>-</span>
          </td>
          <td>{{ item.expense.name }}</td>
          <td class="text-right">
            {{ item.definition ? item.definition.particularValue : 0 | currency }}
          </td>
        </tr>
        </tbody>
      </table>
      <template slot="footer">
        <button class="btn" @click="expenseModal.show = false">Sair</button>
      </template>
    </dx-modal>
  </div>
</template>
<script>
import { randomHash } from '@/helpers';
import { mapMutations } from 'vuex';

export default {
  props: {
    saving: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      source: 'appointments',
      editing: false,
      printing: false,
      deleting: false,
      loading: false,
      expense: null,
      referralTypes: [
        { code: 'consultation', name: 'Guia de Consulta' },
        { code: 'sadt', name: 'Guia de SP/SADT' },
      ],
      referralType: null,
      filterBySchedule: true,
      expenseModal: {
        loading: false,
        show: false,
        data: {
          items: [],
          hasMore: false,
          limit: 0,
          offset: 0,
        },
      },
      preparationModal: {
        show: false,
        printing: false,
        expenseId: '',
        preparation: '',
      },
      account: {
        type: '',
        data: {},
        show: false,
      },
      form: {},
    };
  },
  created() {
    this.form = this.$store.state.appointment.form;
  },
  computed: {
    groupedAccounts() {
      return this.form.expenses
        .reduce((result, expense) => {
          let found = result.find(({ id }) => expense.accountId === id);
          if (!found) {
            found = {
              id: expense.accountId,
              key: expense.accountId || 'no-account',
              expenses: [],
            };
            result.push(found);
          }
          found.expenses.push(expense);
          return result;
        }, [])
        .sort((a, b) => {
          if (!a.id) return -1;
          if (!b.id) return 1;
          return 0;
        });
    },
    canSearch() {
      return this.form.insurance.plan.id && this.form.professional.id;
    },
    preparation() {
      if (!this.preparationModal.preparation) return '';

      return this.preparationModal.preparation
        .replace(/(<figure([^>]+)>)/ig, '')
        .replace(/<\/figure>/ig, '')
        .replace(/<table>/ig, '<table class="table">');
    },
  },
  methods: {
    ...mapMutations({
      showAccountModal: 'Appointment.SHOW_ACCOUNT_MODAL',
      addExpense: 'Appointment.ADD_EXPENSE',
      deleteExpense: 'Appointment.DELETE_EXPENSE',
      setAccount: 'Appointment.SET_ACCOUNT',
    }),
    total(account) {
      return account.expenses
        .reduce((a, b) => a + Number(b.particularValue
          * b.quantity * (b.factor ? b.factor : 1)), 0);
    },
    findExpense(search) {
      const params = {
        search,
        insuranceId: this.form.insurance.id,
        planId: this.form.insurance.plan.id,
        limit: 30,
        offset: 0,
      };

      if (this.filterBySchedule) {
        params.scheduleId = this.form.schedule.id;
      }

      return this.$http
        .get(`/professionals/${this.form.professional.id}/expense-prices`, { params })
        .then(({ data }) => {
          if (data.items.length === 0) {
            return [{
              id: null,
              name: 'Procedimento não encontrado neste convênio',
              quantity: 0,
              factor: 0,
              value: {
                insurance: 0,
                particular: 0,
                total: 0,
              },
            }];
          }
          return data.items;
        });
    },
    addAppointmentExpense(expense) {
      if (!expense || expense.expense.id === null) {
        return;
      }

      this.addExpense({
        id: null,
        isNew: true,
        key: randomHash(),
        selected: true,
        accountId: null,
        expense: {
          id: expense.expense.id,
          code: expense.code,
          type: expense.expense.type,
          name: expense.expense.name,
          specialty: expense.specialty || null,
        },
        return: false,
        quantity: 1,
        factor: 1,
        insuranceValue: expense.definition.insuranceValue,
        particularValue: expense.definition.particularValue,
      });

      if (expense.definition.insuranceValue + expense.definition.particularValue === 0) {
        this.$toast.show('Atenção! Procedimento ainda não precificado.', { type: 'error' });
      }

      this.$emit('validateScheduleInfo');

      if (expense.hasPreparation) {
        this.getPreparation(expense.expense.id);
      }

      this.expense = null;
    },
    print() {
      this.preparationModal.printing = true;
      return this.$file
        .print(`/expenses/${this.preparationModal.expenseId}/print-preparation`)
        .catch(() => {})
        .finally(() => {
          this.preparationModal.printing = false;
        });
    },
    openExpenseModal() {
      this.loadExpenseModalItems();
      this.expenseModal.show = true;
    },
    async loadExpenseModalItems() {
      this.expenseModal.loading = true;
      this.expenseModal.items = [];

      const params = {
        insuranceId: this.form.insurance.id,
        planId: this.form.insurance.plan.id,
        limit: 30,
        offset: 0,
      };

      if (this.filterBySchedule) {
        params.scheduleId = this.form.schedule.id;
      }

      this.$http.get(`/professionals/${this.form.professional.id}/expense-prices`, { params })
        .then(({ data }) => {
          this.expenseModal.data.hasMore = data.hasMore;
          this.expenseModal.data.items = data.items;
        })
        .catch(() => {})
        .finally(() => {
          this.expenseModal.loading = false;
        });
    },
    selectExpense(item) {
      this.addAppointmentExpense(item);
      this.expenseModal.show = false;
    },
    deleteAppointmentExpense(expense) {
      this.deleteExpense(expense);
    },
    getPreparation(id) {
      this.$http.get(`/expenses/${id}`)
        .then(({ data }) => {
          if (data.preparation) {
            this.preparationModal.expenseId = id;
            this.preparationModal.preparation = data.preparation;
            this.preparationModal.show = true;
          } else {
            this.$toast.show('Procedimento sem preparo cadastrado', { type: 'error' });
          }
        });
    },
  },
};
</script>

<style lang="scss">
@import 'src/assets/scss/variables';
.expense-modal {
  .account {
    background-color: #eee;
    padding: .4rem;
    border: 1px solid $border-color;
  }
  .account-finished {
    background-color: lighten($gray-color-light, 4%);
  }
  .expense-modal-table {
    border-left: 1px solid $border-color;
    border-right: 1px solid $border-color;
    &.table-hover {
      tr:hover {
        background-color: lighten($border-color, 6%);
      }
    }
  }
  #div-register-service li a:hover {
    background-color: $gray-color-light;
    color: black;
  }
}

#modal-preparation {
  .preparation-content {
    background-color: $gray-color-ultra-light;
    border: $border-width solid $border-color;
    border-radius: $border-radius;
    padding: $layout-spacing-lg;
    p {
      margin-bottom: $layout-spacing;
    }
  }
}
</style>
